import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-65dba3a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "考试剩余时间", -1))

import { ref, onMounted } from 'vue'
    
export default /*#__PURE__*/_defineComponent({
  __name: 'Time',
  props: ['examMinutes', 'sysTime', 'paperTime'],
  emits: ['timeUp'],
  setup(__props, { emit: __emit }) {

    const props = __props
    const emit = __emit
    const hour_time:string = ref('')
    const isTime:boolean = ref(false)
    let TIMER:any = null;
    const MAX_TIME = props.examMinutes * 60 * 1000

    onMounted(() => {
        showtime()
    })

    const showtime = () => {
        TIMER && clearTimeout(TIMER)
        let singTime = new Date( props.paperTime.signInTime )
        let endtime = new Date( singTime.getTime() + MAX_TIME);  //定义结束时间
        let lefttime = endtime.getTime() - new Date().getTime(),  //距离结束时间的毫秒数
            leftm,
            lefts;
        if ( lefttime <= 0 ) {
            hour_time.value = '00:00'
            TIMER && clearTimeout(TIMER)
            emit('timeUp')
        } else {
            leftm = '00' + Math.floor(lefttime/(1000*60)/60),  //计算分钟数
            lefts = '00' + Math.floor(lefttime/(1000*60)%60);  //计算秒数
            let time = lefttime / (60 * 1000);
            if (  time < 60 ) {
                leftm = Math.floor(lefttime/(1000*60)%60);  //计算分钟数
                lefts = Math.floor(lefttime/1000%60);  //计算秒数
                hour_time.value = leftm + '分' + lefts +'秒'
                if ( time < 10 ) {
                    isTime.value = true
                }
            } else {
                leftm = Math.floor(lefttime/(1000*60)/60);  //计算分钟数
                lefts = Math.floor(lefttime/(1000*60)%60);  //计算秒数
                hour_time.value = leftm + '小时' + lefts +'分'
            }
            TIMER = setTimeout(() => {
                showtime()
            }, 1000)
        }
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["time_box", { 'root_yellow' : isTime.value }])
  }, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createTextVNode(_toDisplayString(hour_time.value), 1)
    ])
  ], 2))
}
}

})